import { render } from "./ImportPropertiesModal.vue?vue&type=template&id=0623a3bc&scoped=true"
import script from "./ImportPropertiesModal.vue?vue&type=script&lang=js"
export * from "./ImportPropertiesModal.vue?vue&type=script&lang=js"

import "./ImportPropertiesModal.vue?vue&type=style&index=0&id=0623a3bc&scoped=true&lang=css"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0623a3bc"]])

export default __exports__